import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabList from "@mui/lab/TabList";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Approval from "./Approval";
import AllPodcast from "./AllPodcast";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
 
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));

const Feed = (props) => {
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  useEffect(() => {
    if (
      userInfo &&
      userInfo.rolesInfo &&
      userInfo.rolesInfo.title.toLowerCase() == "trainer"
    ) {
      setValue("1");
    } else {
      setValue("2");
    }
  }, [userInfo]);

  return (
    <Grid container style={{ justifyContent: "center", flexDirection: "row" }}>
      <Grid item sx={{ flex: 1, textAlign: "center" }}>
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                centered
                sx={{ mt: 2 }}
              >
                {userInfo &&
                  userInfo.rolesInfo &&
                  userInfo.rolesInfo.title.toLowerCase() == "trainer" && (
                    <Tab
                      label="Approve Podcast"
                      value="1"
                      sx={{
                        px: 12,
                        textTransform: "inherit",
                        fontWeight: "600",
                        color: "#a1b8fc",
                        fontSize: "1rem",
                        "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                      }}
                    />
                  )}
                <Tab
                  label="Podcast"
                  value="2"
                  sx={{
                    px: 12,
                    textTransform: "inherit",
                    fontWeight: "600",
                    color: "#a1b8fc",
                    fontSize: "1rem",
                    "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                  }}
                />
                {/* <Tab
                  label="Video Channel"
                  value="3"
                  sx={{
                    px: 12,
                    textTransform: "inherit",
                    fontWeight: "600",
                    color: "#a1b8fc",
                    fontSize: "1rem",
                    "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                  }}
                /> */}
              </TabList>
            </Box>
            <TabPanel value="1">
              <Approval></Approval>
            </TabPanel>
            <TabPanel value="2">
              <AllPodcast></AllPodcast>
            </TabPanel>
            {/* <TabPanel value="3" sx={{ padding: "18px" }}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Grid item>
                  <Card
                    sx={{ maxWidth: 330, textAlign: "left", boxShadow: "none" }}
                  >
                    <CardMedia>
                      <video
                        width="100%"
                        preload="auto"
                        disablePictureInPicture
                        controlsList="nodownload"
                        controls={true}
                        autoPlay
                        loop
                        muted
                        poster="https://assets.codepen.io/6093409/river.jpg"
                      >
                        <source
                          src="https://assets.codepen.io/6093409/river.mp4"
                          type="video/mp4"
                        />
                      </video>
                    </CardMedia>
                    <CardContent sx={{ padding: "5px", paddingBottom: "5px" }}>
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: "500",
                          color: "#DB8829",
                        }}
                      >
                        Vocablab Feature Video
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#AFAFAF",
                        }}
                      >
                        4 min 02 sec
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item>
                  <Card
                    sx={{ maxWidth: 330, textAlign: "left", boxShadow: "none" }}
                  >
                    <CardMedia>
                      <video
                        width="100%"
                        preload="auto"
                        disablePictureInPicture
                        controlsList="nodownload"
                        controls={true}
                        autoPlay
                        loop
                        muted
                        poster="https://assets.codepen.io/6093409/river.jpg"
                      >
                        <source
                          src="https://assets.codepen.io/6093409/river.mp4"
                          type="video/mp4"
                        />
                      </video>
                    </CardMedia>
                    <CardContent sx={{ padding: "5px", paddingBottom: "5px" }}>
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: "500",
                          color: "#DB8829",
                        }}
                      >
                        Vocablab Feature Video
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#AFAFAF",
                        }}
                      >
                        4 min 02 sec
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item>
                  <Card
                    sx={{ maxWidth: 330, textAlign: "left", boxShadow: "none" }}
                  >
                    <CardMedia>
                      <video
                        width="100%"
                        preload="auto"
                        disablePictureInPicture
                        controlsList="nodownload"
                        controls={true}
                        autoPlay
                        loop
                        muted
                        poster="https://assets.codepen.io/6093409/river.jpg"
                      >
                        <source
                          src="https://assets.codepen.io/6093409/river.mp4"
                          type="video/mp4"
                        />
                      </video>
                    </CardMedia>
                    <CardContent sx={{ padding: "5px", paddingBottom: "5px" }}>
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: "500",
                          color: "#DB8829",
                        }}
                      >
                        Vocablab Feature Video
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#AFAFAF",
                        }}
                      >
                        4 min 02 sec
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item>
                  <Card
                    sx={{ maxWidth: 330, textAlign: "left", boxShadow: "none" }}
                  >
                    <CardMedia>
                      <video
                        width="100%"
                        preload="auto"
                        disablePictureInPicture
                        controlsList="nodownload"
                        controls={true}
                        autoPlay
                        loop
                        muted
                        poster="https://assets.codepen.io/6093409/river.jpg"
                      >
                        <source
                          src="https://assets.codepen.io/6093409/river.mp4"
                          type="video/mp4"
                        />
                      </video>
                    </CardMedia>
                    <CardContent sx={{ padding: "5px", paddingBottom: "5px" }}>
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          fontWeight: "500",
                          color: "#DB8829",
                        }}
                      >
                        Vocablab Feature Video
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#AFAFAF",
                        }}
                      >
                        4 min 02 sec
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </TabPanel> */}
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Feed;
